import { render, staticRenderFns } from "./GiftSelectionDialog.vue?vue&type=template&id=027990a4&scoped=true"
import script from "./GiftSelectionDialog.vue?vue&type=script&lang=js"
export * from "./GiftSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./GiftSelectionDialog.vue?vue&type=style&index=0&id=027990a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027990a4",
  null
  
)

export default component.exports